// @flow
const initialState = {
  firstName: '',
  lastName:'',
  password: '',
  confirmPassword: '',

};
export default initialState;